<template>
  <div class="layout-inner">
    <div class="side">
      <side-menu></side-menu>
    </div>
    <div class="main">
      <div class="header">
        <custom-header></custom-header>
      </div>
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import CustomHeader from './CustomHeader'
import SideMenu from './SideMenu'

import user from '../api/user'

export default {
  name: 'basicLayout',
  components: {
    CustomHeader,
    SideMenu,
  },
  data() {
    return {
      menuList: [
        // {id: '1',  name: '概况',icon: 'pie-chat'},
        // {id: '4',name: '课程',icon: 'course',children: [
        //   {id: '4-1',name: '课程管理',path: 'courseList'},
        // ]},
        // {id: '10',name: '老师',icon: 'teacher',children: [
        //   {id: '10-1',name: '老师管理',path: 'teacherList'},
        // ]},
        // {id: '5',name: '学生',icon: 'student',children: [
        //   {id: '5-1',name: '学生管理',path: 'studentList'},
        // ]},
        // {id: '6',name: '教务',icon: 'teaching',children: [
        //   {id: '6-1',name: '课表',path: 'schedule'},
        //   {id: '6-2',name: '班级',path: 'classList'},
        //   {id: '6-3',name: '教室',path: 'classroom'},
        //   {id: '6-4',name: '设置',path: 'educationSet'},
        //   ]},
        // {id: '7',name: '活动',icon: 'activity',children: [
        //   {id: '7-1',name: '平台活动',path: 'sysActivityList'},
        //   {id: '7-2',name: '学校活动',path: 'schoolActivityList'},
        //   {id: '7-3',name: '课程方活动',path: 'institutionActivityList'},
        // ]},
        // {id: '9',name: '财务',icon: 'finance',children: [
        //   {id: '9-1',name: '订单',path: 'finOrderList'},
        // ]},
        // {id: '8',name: '广告',icon: 'banner',children: [
        //   {id: '8-1',name: '广告管理',path: 'bannerList'},
        // ]},
        // {id: '11',name: '模块',icon: 'model',children: [
        //   {id: '11-1',name: 'APP模块管理',icon: 'pie-chat',path: 'appModuleList'},
        // ]},
        // {id: '3',name: '设置',icon: 'setting',children: [
        //   {id: '3-1',name: '人员管理',path: 'personList'},
        //   {id: '3-2',name: '代理管理',path: 'agencyList'},
        //   {id: '3-3',name: '教育局管理',path: 'bureauList'},
        //   {id: '3-4',name: '学校管理',path: 'schoolList'},
        //   {id: '3-5',name: '课程方管理',path: 'institutionList'},
        //   {id: '3-6',name: '角色管理',path: 'roleList'},
        //   {id: '3-7',name: '权限管理',path: 'permissionList'},
        // ]},
      ],
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

$sideWidth: 100px;

.layout-inner {
  font-size: 0px;
  font-family: 600;
  height: 100vh;
  overflow: hidden;
  display: flex;
  background: $bg-color;
}
.side {
  flex: none;
  vertical-align: top;
  display: inline-block;
}
.main {
  flex: 1;
  // overflow-x: auto;
}
.content {
  width: 100%;
  font-size: 16px;
  display: inline-block;
  height: calc(100vh - 64px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
